import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import type { SxProps } from "@mui/material";
import dayjs from "dayjs";
import "./styles.scss";
import classNames from "classnames";
import { useValidationBlur } from "../../hooks/useValidationBlur";

export const HdgDatePicker = ({
  value,
  onChange,
  label,
  disabled = false,
  isValid = false,
  validationText,
  helperText,
  textFieldSx,
}: {
  label?: string;
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  isValid?: boolean;
  validationText?: string;
  helperText?: string;
  textFieldSx?: SxProps;
}) => {
  const { shouldValidate, onBlur } = useValidationBlur();

  const isInvalidState = !isValid && shouldValidate && !disabled;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        disabled={disabled}
        className={classNames(
          "hdg-date-picker",
          !isValid && shouldValidate && "error"
        )}
        label={label}
        value={value ? dayjs(value) : null}
        onClose={onBlur}
        slotProps={{
          textField: {
            onBlur: onBlur,
            error: isInvalidState,
            helperText:
              isInvalidState && !!validationText ? validationText : helperText,
            sx: textFieldSx,
          },
        }}
        onChange={(changeValue) =>
          onChange(
            changeValue ? changeValue?.format("YYYY-MM-DD") : changeValue
          )
        }
      />
    </LocalizationProvider>
  );
};
